module.exports = __webpack_public_path__ + "static/media/arrow.f9f2a3dc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/static/audio/arrow.mp3
// module id = 523
// module chunks = 0